import React from "react";
import { MagicLink } from "../ui";
import "./Eyebrow.style.scss";

export interface EyebrowProps {
    topic_name?: string;
    url?: string;
}

export const Eyebrow = ({ url, topic_name }: EyebrowProps) => {
    if (url && topic_name) {
        return (
            <nav className="component-eyebrow">
                <MagicLink to={url}>{topic_name}</MagicLink>
            </nav>
        );
    } else if (topic_name) {
        return <nav className="component-eyebrow">{topic_name}</nav>;
    }
    return null;
};

export default Eyebrow;
